import update from 'immutability-helper';
import {isDirty} from 'redux-form';
import {areDirtyTimesheets as areDirtyEmployeeTimesheets} from './employeeTimesheets/employeeTimesheets.reducer';
import {areDirtyTimesheets as areDirtyEquipmentTimesheets} from './equipmentTimesheets/equipmentTimesheets.reducer';
import {areDirtyMaterials, materials} from './material/material.reducer';
import {areDirtyTimesheets as areDirtySubContractorsTimesheets} from './subcontractorTimesheets/subcontractorTimesheets.reducer';

export const API_CREATE_WORK_ORDER = 'API_CREATE_WORK_ORDER';
export const API_UPDATE_WORK_ORDER = 'API_UPDATE_WORK_ORDER';
export const API_LOAD_WORK_ORDER = 'API_LOAD_WORK_ORDER';
export const API_REMOVE_WORK_ORDER = 'API_REMOVE_WORK_ORDER';
export const API_LOAD_WORK_ORDER_LOADED = 'API_LOAD_WORK_ORDER_LOADED';
export const API_LOAD_WORK_ORDERS = 'API_LOAD_WORK_ORDERS';
export const API_LOAD_WORK_ORDERS_LOADED = 'API_LOAD_WORK_ORDERS_LOADED';

export const API_CREATE_WORK_ORDER_SUCCESS = 'API_CREATE_WORK_ORDER_SUCCESS';
export const UNSET_NEW_ID = 'UNSET_NEW_ID';
export const SORT_BY_PROJECT_NAME = 'SORT_BY_PROJECT_NAME';
export const SORT_BY_DATE = 'SORT_BY_DATE';
export const REDIRECT_TO_NEW = 'REDIRECT_TO_NEW';
export const MATERIAL_SET_NONE = 'MATERIAL_SET_NONE';
export const TAILGATE_SET_NONE = 'TAILGATE_SET_NONE';
export const NEW_WORK_ORDER = 'NEW_WORK_ORDER';
export const TAILGATE_UNSET_ERRORS = 'TAILGATE_UNSET_ERRORS';
export const TAILGATE_SET_ERROR = 'TAILGATE_SET_ERROR';

const API_LOAD_WORK_ORDER_FAILED = 'API_LOAD_WORK_ORDER_FAILED';
const API_LOAD_WORK_ORDER_LOADING = 'API_LOAD_WORK_ORDER_LOADING';
const API_LOAD_WORK_ORDERS_FAILED = 'API_LOAD_WORK_ORDERS_FAILED';
const API_LOAD_WORK_ORDERS_LOADING = 'API_LOAD_WORK_ORDERS_LOADING';
const API_UPDATE_WORK_ORDER_SUCCESS = 'API_UPDATE_WORK_ORDER_SUCCESS';
const API_UPDATE_WORK_ORDER_LOADING = 'API_UPDATE_WORK_ORDER_LOADING';
const API_REMOVE_WORK_ORDER_LOADING = 'API_REMOVE_WORK_ORDERS_LOADING';
const API_REMOVE_WORK_ORDER_SUCCESS = 'API_REMOVE_WORK_ORDER_SUCCESS';
const API_REMOVE_WORK_ORDER_FAILED = 'API_REMOVE_WORK_ORDER_FAILED';

const defaultState = {workOrders: {}, sort: 'date', loading: false, newId: undefined, redirect: false};
const emptyWorkOrder = () => ({removing: false, dirty: false, project: {name: ''}});

// eslint-disable-next-line object-curly-newline
export const reducer = (state = defaultState, {type, response, replaceId, id, anyMaterials, hasTailgate}) => {
    switch (type) {
        case TAILGATE_SET_ERROR:
            return update(state, {workOrders: {[id]: {tailgate_error: {$set: 'You must either add a tailgate meeting document or select "No Tailgate."'}}}});
        case TAILGATE_UNSET_ERRORS:
            return update(state, {workOrders: {[id]: {tailgate_error: {$set: undefined}}}});
        case NEW_WORK_ORDER:
            return update(state, {workOrders: {new: {$set: {...emptyWorkOrder()}}}});
        case MATERIAL_SET_NONE:
            return update(state, {workOrders: {[id]: {no_materials: {$set: anyMaterials}, dirty: {$set: true}}}});
        case TAILGATE_SET_NONE:
            return update(state, {workOrders: {[id]: {no_tailgate: {$set: hasTailgate}, dirty: {$set: true}}}});
        case API_LOAD_WORK_ORDER_FAILED:
        case API_LOAD_WORK_ORDERS_FAILED:
            return update(state, {loading: {$set: false}});
        case API_LOAD_WORK_ORDER_LOADING:
        case API_LOAD_WORK_ORDERS_LOADING:
        case API_UPDATE_WORK_ORDER_LOADING:
            return update(state, {loading: {$set: true}});
        case API_LOAD_WORK_ORDER_LOADED:
            return update(state,
                {
                    loading: {$set: false},
                    workOrders: {[response.id]: {$set: {...emptyWorkOrder(), ...response}}},
                });
        case API_LOAD_WORK_ORDERS_LOADED:
            return update(state,
                {
                    loading: {$set: false},
                    workOrders: {$set: response.reduce((obj, next) => Object.assign(obj, {[next.id]: next}), {})},
                });
        case API_UPDATE_WORK_ORDER_SUCCESS:
            return update(state, {loading: {$set: false}, workOrders: {[response.id]: {$set: response}}});
        case API_CREATE_WORK_ORDER_SUCCESS:
            return update(state, {
                workOrders: {
                    [response.id]: {$set: response},
                    $unset: [replaceId],
                    new: {$set: {...emptyWorkOrder()}},
                },
                newId: {$set: response.id},
            });
        case UNSET_NEW_ID:
            return update(state, {newId: {$set: undefined}, redirect: {$set: false}});
        case REDIRECT_TO_NEW:
            return update(state, {redirect: {$set: true}});
        case API_REMOVE_WORK_ORDER_FAILED:
            return update(state, {workOrders: {[id]: {removing: {$set: false}}}});
        case API_REMOVE_WORK_ORDER_LOADING:
            return update(state, {workOrders: {[id]: {removing: {$set: true}}}});
        case API_REMOVE_WORK_ORDER_SUCCESS:
            return update(state, {workOrders: {$unset: [id]}});
      case SORT_BY_DATE:
            return update(state, {sort: {$set: 'date'}});
      case SORT_BY_PROJECT_NAME:
        return update(state, {sort: {$set: 'project'}});
        default:
            return state;
    }
};

const groupBy = (xs, key) => xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
}, {});

const sortWorkOrders = (sort, a,b) => sort === 'date' ? sortByDate(a, b) : sortByProject(a, b);
const sortByDate = (a,b) => new Date(b.wo_date) - new Date(a.wo_date);
const sortByProject = (a,b) => new Date(a.project.name) - new Date(b.project.name);

export const newId = state => state.workOrders.newId;
export const redirect = state => state.workOrders.redirect;

export const draftWorkOrders = state => Object.values(state.workOrders.workOrders)
    .filter(w => w.status === null)
    .sort((a, b) => sortWorkOrders(state.workOrders.sort, a, b));
export const nonDraftWorkOrders = state => Object.values(state.workOrders.workOrders)
    .filter(w => w.status !== null)
    .sort((a, b) => sortWorkOrders(state.workOrders.sort, a, b));

export const submittedWorkOrders = state => Object.values(state.workOrders.workOrders)
    .filter(w => w.status === 'submitted')
    .sort((a, b) => sortWorkOrders(state.workOrders.sort, a, b));
export const approvedWorkOrders = state => Object.values(state.workOrders.workOrders)
    .filter(w => w.status === 'approved')
    .sort((a, b) => sortWorkOrders(state.workOrders.sort, a, b));

export const workOrders = state => Object.values(state.workOrders.workOrders).sort((a, b) => sortWorkOrders(state.workOrders.sort, a, b));

export const projectWorkOrders = state => Object.values(groupBy(workOrders(state), 'project_id'));
export const workOrder = (state, id) => state.workOrders.workOrders[id];
export const loading = state => state.workOrders.loading;
export const dirty = (state, id) => workOrder(state, id) &&
    (isDirty(`workOrder${id}`)(state) ||
        workOrder(state, id).dirty ||
        areDirtyEmployeeTimesheets(state) ||
        areDirtyEquipmentTimesheets(state) ||
        areDirtyMaterials(state) ||
        areDirtySubContractorsTimesheets(state));

export const noMaterials = (state, id) => (workOrder(state, id) ? workOrder(state, id).no_materials : false);
export const noTailgate = (state, id) => (workOrder(state, id) ? workOrder(state, id).no_tailgate : false);
export const tailgateError = (state, id) => (workOrder(state, id) ? workOrder(state, id).tailgate_error : null);
export const approvedMaterials = (state, id) => materials(id, state).length > 0 || noMaterials(state, id);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/workOrder/workOrders.reducer.js